import { saveState } from "../api";
import { objectsAreEqual } from "../utils";

export interface User {
  email: string;
  name: string;
}

export interface ShoppingListItem {
  amount: number;
  name: string;
  visible: boolean;
}

export enum DestinationType {
  EMAIL = "email",
  TEXT = "text",
}
export interface Reminder {
  date: Date;
  destination: string;
  destinationType: DestinationType;
  message: string;
  subject?: string;
}

export interface Ingredient {
  // amount?: number;
  // brands?: string[];
  // imageUrls?: string[];
  // location?: Record<string, number>; // store: isle
  name: string;
  // shoppingUnit?: number;
  showAsShoppingListItem?: boolean; // e.g. spice is false
  // unit?: string;
}

export interface Instruction {
  instructions: string[];
  cookProcess?: string;
  cookTemperature?: string;
  cookTime?: string;
  ingredients?: Ingredient[];
  notes?: string[];
  prepTime?: string;
  reminders?: Reminder[];
  tips?: string[];
  totalTime?: string;
}

export interface Recipe {
  imageUrls?: string[];
  instructions: Instruction[];
  author?: string;
  name: string;
}

export enum MealOrder {
  BREAKFAST = 0,
  DINNER = 30,
  LUNCH = 10,
  SNACK = 20,
}

export enum MealName {
  BREAKFAST = "breakfast",
  DINNER = "dinner",
  LUNCH = "lunch",
  SNACK = "snack",
}

export const MealNameToOrder: Record<MealName, MealOrder> = {
  [MealName.BREAKFAST]: MealOrder.BREAKFAST,
  [MealName.DINNER]: MealOrder.DINNER,
  [MealName.LUNCH]: MealOrder.LUNCH,
  [MealName.SNACK]: MealOrder.SNACK,
};

export interface MenuItem {
  date: Date;
  mealName: string;
  mealOrder: number;
  recipe?: Recipe;
  selected: boolean;
}

export enum ModalNames {
  // LOGIN = "login",
  NEW_RECIPE = "newRecipe",
  RECIPE_BOOK = "recipeBook",
  RECIPE_CARD = "recipeCard",
  SETTINGS = "settings",
  CONFIRMATION = "confirmation",
}

export interface StateProps {
  state: State;
  setState: React.Dispatch<React.SetStateAction<State>>;
}

export interface Settings {
  meals: string[];
  defaultMeal: string;
  mealSelectionExpanded: boolean;
  mealsExpanded: boolean;
  shoppingListExpanded: boolean;
  selectedStore: string;
  isleToIngredients: Record<string, string[]>;
  authorizedUsers?: string[];
  sharedStateName?: string;
}

export const defaultSettings: Settings = {
  meals: ["dinner"],
  defaultMeal: "dinner",
  mealsExpanded: true,
  mealSelectionExpanded: false,
  shoppingListExpanded: false,
  selectedStore: "",
  isleToIngredients: {
    "1": [],
  },
  sharedStateName: undefined,
  authorizedUsers: [],
};

export interface State {
  additionalItems: string[];
  darkMode: boolean;
  loading: boolean;
  loggingIn: boolean;
  menu: Record<string, MenuItem>;
  openModals: Record<ModalNames, boolean>;
  // recipes: Record<string, Recipe>;
  selectedMealName: MealName | string;
  shoppingList: ShoppingListItem[];
  shoppingListHistory: string[];
  staples: string[];
  itemsInCart?: string[];
  searchResults?: string[];
  selectedRecipe?: Recipe;
  settings?: Settings;
  user?: User;
}

export const blankState: State = {
  additionalItems: [],
  darkMode: true,
  loading: true,
  loggingIn: false,
  menu: {},
  openModals: {
    // login: false,
    newRecipe: false,
    recipeBook: false,
    recipeCard: false,
    settings: false,
    confirmation: false,
  },
  // recipes: {},
  selectedMealName: MealName.DINNER,
  shoppingList: [],
  shoppingListHistory: [],
  staples: [],
  settings: defaultSettings,
};

export interface SaveStateToDbProps {
  readonly localStorageEmailKey: string;
  readonly state: State;
  readonly lastState: State | undefined;
  readonly setLastState: React.Dispatch<
    React.SetStateAction<State | undefined>
  >;
  readonly conditionalCheckFailCount: number;
  readonly setConditionalCheckFailCount: React.Dispatch<
    React.SetStateAction<number>
  >;
  readonly setState:
    | React.Dispatch<React.SetStateAction<State>>
    | React.Dispatch<React.SetStateAction<State | undefined>>;
  readonly setSnackbarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  readonly forceSave?: boolean;
}
export async function saveStateToDb(props: SaveStateToDbProps) {
  const {
    localStorageEmailKey,
    state,
    lastState,
    setLastState,
    conditionalCheckFailCount,
    setConditionalCheckFailCount,
    setState,
    setSnackbarOpen,
    forceSave,
  } = props;
  const email = localStorage.getItem(localStorageEmailKey);
  if (email) {
    try {
      await saveState({
        email,
        state,
        lastState,
        forceSave,
      });
      if (!objectsAreEqual(state, blankState)) {
        setLastState(state);
      }
    } catch (err: any) {
      if (err.message === "The conditional request failed") {
        setSnackbarOpen(true);
        setConditionalCheckFailCount((prev) => prev + 1);
      } else {
        throw err;
      }
      /*
      if (
        err.message === "The conditional request failed" &&
        conditionalCheckFailCount < 3
      ) {
        setConditionalCheckFailCount((prev) => prev + 1);
        const sharedStateName = state.settings?.sharedStateName;
        const loadedState = await loadState({ email, sharedStateName });
        if (loadedState) {
          const userState = JSON.parse(loadedState) as State;
          setState(userState);
          // setLastState(userState);
        }
      } else if (conditionalCheckFailCount >= 3) {
        setSnackbarOpen(true);
        setConditionalCheckFailCount(0);
      }
      */
    }
  }
}
